import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

function stripHtml(input: string, sanitizer: DomSanitizer): string {
  if (!input) return '';

  // First, use Angular's sanitizer to remove dangerous content (scripts, event handlers, etc.)
  // SecurityContext.HTML = 1
  const sanitized = sanitizer.sanitize(1, input) || '';

  // Use DOMParser to safely parse HTML without executing scripts
  // DOMParser.parseFromString does not execute scripts, unlike innerHTML
  const parser = new DOMParser();
  const doc = parser.parseFromString(sanitized, 'text/html');
  return doc.body.textContent || doc.body.innerText || '';
}

@Pipe({
  name: 'stripHtml',
})
export class StripHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any): string {
    if (!value) return '';
    return stripHtml(String(value), this.sanitizer);
  }
}
